import { Card, Row, Col } from "react-bootstrap";
import "./styles.scss";
import { useTranslation } from "react-i18next";

export function CategoryCard({
  title,
  iconSrc,
  description,
  iconAlt = "",
  href,
  onClick,
}: {
  title: string;
  description: string;
  iconSrc: string;
  iconAlt?: string;
  href?: string;
  onClick?: () => void;
}) {
  const { t } = useTranslation("statistics");

  const content = (
    <Card
      className={`w-100 h-100 p-4 d-flex flex-column card-container align-items-center gap-2 ${
        onClick ? "clickable" : ""
      }`}
    >
      <div className="w-100 d-flex align-items-start justify-content-center">
        <img
          alt={t(iconAlt || title)}
          className="category-card-img"
          src={iconSrc}
        />
      </div>

      <strong className="card-text-style overflow-hidden text-wrap text-center">
        {t(title)}
      </strong>
      <p className="text-center mb-0">{t(description)}</p>
    </Card>
  );

  if (href) {
    return (
      <a
        href={href}
        className="text-decoration-none d-block h-100 w-100"
        onClick={onClick}
        aria-label={title}
      >
        {content}
      </a>
    );
  }
  return (
    <div
      role="button"
      onClick={onClick}
      className="text-decoration-none d-block h-100 w-100"
    >
      {content}
    </div>
  );
}

export default function CategoryGrid({
  items,
  threeCols,
}: {
  threeCols?: boolean;
  items: Array<{
    title: string;
    description: string;
    iconSrc: string;
    iconAlt?: string;
    tileColor?: string;
    href?: string;
    onClick?: () => void;
  }>;
}) {
  return (
    <Row className="g-4 g-md-4 g-lg-4">
      {items.map((it, idx) => (
        <Col
          key={idx}
          xs={12}
          sm={6}
          lg={threeCols ? 3 : 4}
          className="d-flex justify-content-center"
        >
          <CategoryCard
            title={it.title}
            description={it.description}
            iconSrc={it.iconSrc}
            iconAlt={it.iconAlt}
            href={it.href}
            onClick={it.onClick}
          />
        </Col>
      ))}
    </Row>
  );
}
